import React, { useContext } from 'react';
import styled from 'styled-components';
import { GithubContext } from '../context/context';
import { Pie, Column, Bar, Doughnut, ExampleChart } from './Charts';
import { AuthContext } from "../context/auth";
import { FETCH_POST_QUERY } from "../util/graphql";
import { useQuery } from "@apollo/react-hooks";

 
const Repos = () => {
  const { furnitures } = React.useContext(GithubContext);
  const { repos } = React.useContext(GithubContext);
   const { posts } = React.useContext(GithubContext);

  //  const { loading, data: { getPosts: posts } = {} } = useQuery(
  //   FETCH_POST_QUERY
  // );

  const { user } = React.useContext(AuthContext);

  const chartData = [
  {
    label: "Requested ",
    value: "200"
  },
  {
    label: "Received",
    value: "10"
  },
  {
    label: "Replied",
    value: "0"
  },
  {
    label: "Stalled",
    value: "0"
  }
  
];


// let usernames = furnitures.reduce((total, item)=>{
//   console.log(item);
// },{})


const username = posts.reduce((total, item)=>{
  const { username } = item ;
  console.log(username);
},{})


  const languages = repos.reduce((total, item) => {
    const { language, stargazers_count } = item;
    if (!language) return total;
    if (!total[language]) {
      total[language] = { label: language, value: 1, stars: stargazers_count };
    } else {
      total[language] = {
        ...total[language],
        value: total[language].value + 1,
        stars: total[language].stars + stargazers_count,
      };
    }
    return total;
  }, {});

  const mostUsed = Object.values(languages)
    .sort((a, b) => {
      return b.value - a.value;
    })
    .slice(0, 5);

  // most stars per language

  const mostPopular = Object.values(languages)
    .sort((a, b) => {
      return b.stars - a.stars;
    })
    .map((item) => {
      return { ...item, value: item.stars };
    })
    .slice(0, 5);

  // stars, forks

  let { stars, forks } = repos.reduce(
    (total, item) => {
      const { stargazers_count, name, forks } = item;
      total.stars[stargazers_count] = { label: name, value: stargazers_count };
      total.forks[forks] = { label: name, value: forks };
      return total;
    },
    {
      stars: {},
      forks: {},
    }
  );

  stars = Object.values(stars).slice(-5).reverse();
  forks = Object.values(forks).slice(-5).reverse();
  // console.log(posts);
  // console.log(furnitures);

  return (
    <section className='section'>
      <Wrapper className='section-center'>
        {/* <ExampleChart data ={Chat}/> */}
        <Pie data={chartData} />
        <Column data={chartData} />
        <Doughnut data={chartData} />
        <Bar data={chartData} />
      </Wrapper>
    </section>
  );
};

const Wrapper = styled.div`
  display: grid;
  justify-items: center;
  gap: 2rem;
  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 2fr 3fr;
  }

  div {
    width: 100% !important;
  }
  .fusioncharts-container {
    width: 100% !important;
  }
  svg {
    width: 100% !important;
    border-radius: var(--radius) !important;
  }
`;

export default Repos;
